module.exports = __webpack_public_path__ + "static/leroy_merlin-246149349e8080b86fb4e9a46c23a84e.svg";